module.exports = __webpack_public_path__ + "img/DKV.ff1aed8b.jpg";